import { configureStore } from '@reduxjs/toolkit';
// import RootReducer from './reducer/root/root-reducer';
import RootReducer from './root/root-reducer';

const store = configureStore({
    reducer: RootReducer
});
  
export default store;